var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    rx: 4,
    fill: "white",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3219 11.274C25.2447 11.0371 25.0399 10.8644 24.7937 10.8287L22.4506 10.4881L21.4023 8.36461C21.2925 8.14141 21.065 8 20.8159 8C20.5667 8 20.3392 8.14141 20.2293 8.36461L19.1811 10.4882L16.8376 10.8287C16.5914 10.8645 16.3865 11.0372 16.3094 11.274C16.2324 11.5108 16.2967 11.7709 16.4751 11.9447L18.1713 13.5976L17.7705 15.9313C17.7283 16.1768 17.8293 16.425 18.0308 16.5713C18.2327 16.7182 18.4997 16.7363 18.7199 16.6211L20.816 15.5192L22.9117 16.6211C23.1369 16.7393 23.403 16.7149 23.6008 16.5713C23.8023 16.425 23.9033 16.1769 23.8611 15.9315L23.4607 13.5976L25.1564 11.9447C25.3347 11.7709 25.3985 11.5108 25.3219 11.274Z",
    fill: "#E6ECF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4312 17.9688H18.1972C17.8359 17.9688 17.543 18.2617 17.543 18.623V28.0005H24.0854V18.623C24.0854 18.2617 23.7925 17.9688 23.4312 17.9688Z",
    fill: "#E6ECF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6543 20.5859C11.2929 20.5859 11 20.8789 11 21.2402V27.4835C11 27.7692 11.2316 28.0008 11.5173 28.0008H16.234V20.5859H11.6543Z",
    fill: "#E6ECF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9733 23.2012H25.3936V27.999H30.1103C30.396 27.999 30.6276 27.7674 30.6276 27.4817V23.8554C30.6275 23.4941 30.3346 23.2012 29.9733 23.2012Z",
    fill: "#E6ECF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardActive);
export default __webpack_public_path__ + "static/media/leaderboardActive.f5dd677593a7e7074a856f978e130bb2.svg";
export { ForwardRef as ReactComponent };